// 메뉴 관리 모듈 - ES 모듈로 export
const MenuModule = (function(){
  const btn = document.getElementById('sopHambtn');
  const modal = document.getElementById('sopMobile');
  const backdrop = document.getElementById('sopBackdrop');
  const closeBtn = document.getElementById('sopClose');
  const mobileNav = document.getElementById('sopMobileNav');

  function openModal(){
    if (!modal) return;
    modal.classList.add('show');
    modal.setAttribute('aria-hidden','false');
    if (btn) btn.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';
  }
  function closeModal(){
    if (!modal) return;
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden','true');
    if (btn) btn.setAttribute('aria-expanded','false');
    document.body.style.overflow='';
  }

  if(btn) btn.addEventListener('click', e=>{ e.preventDefault(); modal.classList.contains('show') ? closeModal() : openModal(); });
  if(closeBtn) closeBtn.addEventListener('click', e=>{ e.preventDefault(); closeModal(); });
  if(backdrop) backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', e=>{ if(e.key==='Escape') closeModal(); });

  if(mobileNav){
    mobileNav.addEventListener('click', function(e){
      const prim = e.target.closest('a.sop-primary');
      if(!prim) return;
      const li = prim.closest('li');
      const sub = li.querySelector('ul.sop-sub');
      if(!sub) return;
      e.preventDefault();
      const open = sub.classList.contains('show');
      mobileNav.querySelectorAll('ul.sop-sub.show').forEach(o=>{
        if(o!==sub){ o.classList.remove('show'); o.previousElementSibling?.setAttribute('aria-expanded','false'); } });
      if(open){ sub.classList.remove('show'); prim.setAttribute('aria-expanded','false'); }
      else { sub.classList.add('show'); prim.setAttribute('aria-expanded','true'); }
    });
  }

  // 데스크톱 메인메뉴 관리
  function initDesktopMenu() {
    // 메인메뉴 클릭 방지
    const mainMenuTriggers = document.querySelectorAll('.main-menu-trigger');
    mainMenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        return false;
      });
    });
    
    // 메뉴 항목들
    const menuItems = document.querySelectorAll('.main-menu > li');
    const subMenus = document.querySelectorAll('.sub-menu');
    const subMenuBg = document.querySelector('.sub-menu-bg');
    
    // 모든 활성 상태 제거
    function clearActive() {
      menuItems.forEach(item => item.classList.remove('menu-active'));
    }
    
    // 메뉴 아이템 이벤트
    menuItems.forEach((item, index) => {
      // 1차메뉴 호버
      item.addEventListener('mouseenter', function() {
        clearActive();
        item.classList.add('menu-active');
      });
      
      // 1차메뉴에서 마우스 나감 - 서브메뉴로 이동할 시간 주기
      item.addEventListener('mouseleave', function() {
        setTimeout(() => {
          const subMenu = item.querySelector('.sub-menu');
          if (subMenu && !subMenu.matches(':hover') && subMenuBg && !subMenuBg.matches(':hover')) {
            item.classList.remove('menu-active');

          }
        }, 100);
      });
    });
    
    // 서브메뉴 이벤트
    subMenus.forEach(subMenu => {
      subMenu.addEventListener('mouseenter', function() {
        const parentItem = subMenu.closest('.main-menu > li');
        if (parentItem) {
          clearActive();
          parentItem.classList.add('menu-active');
        }
      });
      
      subMenu.addEventListener('mouseleave', function() {
        setTimeout(() => {
          clearActive();
        }, 50);
      });
    });
    
    // 서브메뉴 배경 이벤트
    if (subMenuBg) {
      subMenuBg.addEventListener('mouseleave', function() {
        setTimeout(() => {
          clearActive();
        }, 50);
      });
    }
  }
  
  // DOM 준비 완료 후 실행
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopMenu);
  } else {
    initDesktopMenu();
  }
  
  // 공개 API 반환
  return {
    openModal,
    closeModal,
    initDesktopMenu
  };
})();

// 전역 객체로도 노출 (하위 호환성)
if (typeof window !== 'undefined') {
  window.MenuModule = MenuModule;
}

// ES 모듈로 export
export default MenuModule;
export { MenuModule };